import { LayoutType, withLayout } from 'hocs/with-layout';
import { OnboardingVaultInfo } from './onboarding-vault-info';

const WrappedOnboardingVaultInfo = withLayout(
  LayoutType.WithOldNavOnly,
  OnboardingVaultInfo,
);

export { WrappedOnboardingVaultInfo as OnboardingVaultInfo };
